import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Rate } from '../model/Rate';

@Injectable({
  providedIn: 'root',
})
export class RatesService {
  constructor(private readonly http: HttpClient) {}

  getRates(): Observable<Array<Rate>> {
    return this.http.get<Array<Rate>>('/ch/api/rate');
  }

  updateRate(command): Observable<void> {
    return this.http.post<void>('/ch/api/rate/update', command);
  }
}
